export var ConverterType;
(function (ConverterType) {
    ConverterType[ConverterType["TO_JSON"] = 0] = "TO_JSON";
    ConverterType[ConverterType["FROM_JSON"] = 1] = "FROM_JSON";
})(ConverterType || (ConverterType = {}));
//# sourceMappingURL=domain.js.map